import PropTypes from "prop-types";
import { Box } from "@mui/material";
import './WithPaymentWrapper.css';

/**
 * WithPaymentWrapper
 * Reusable page wrapper for payment-related screens. Provides a consistent
 * layout and styling for payment pages. Can be used directly

 * as a normal wrapper component or use `withPaymentWrapper` to wrap a
 * page component.
 */
export default function WithPaymentWrapper({
	children,
	className,
}) {
	return (
		<Box className={`withPaymentWrapper ${className}`} sx={{ p: 2 }}>
			{children}
		</Box>
	);
}

WithPaymentWrapper.propTypes = {
	children: PropTypes.node,
	className: PropTypes.string,
};

WithPaymentWrapper.defaultProps = {
	children: null,
	className: undefined,
};



